// @flow
import pipe from 'ramda/es/pipe';
import omit from 'ramda/es/omit';
import prop from 'ramda/es/prop';

import i18n from 'app/i18n';
import action from 'app/common/lib/action';

import api from '../api';


export const ADV_REFUNDED_REQUEST = 'ADV_REFUNDED_REQUEST';
export const ADV_REFUNDED_SUCCESS = 'ADV_REFUNDED_SUCCESS';
export const ADV_REFUNDED_FAILURE = 'ADV_REFUNDED_FAILURE';


/**
* Запрос возможности возврата средств по подпискам
 */
export const advRefundedFetch = (studentId: number) => async (dispatch: Function): Promise<*> => {
  const params = studentId ? { student_id: studentId } : {};
  dispatch(action(ADV_REFUNDED_REQUEST, params));
  try {
    const res = await api('cabinet/subscriptions_exist_and_advance_refunded', 'get', { params });
    const data = pipe(prop('data'), omit(['result']))(res);
    dispatch(action(ADV_REFUNDED_SUCCESS, data));
    return data;
  } catch (error) {
    const errText = i18n.t('app:request_subscribes_failed');
    dispatch(action(
      ADV_REFUNDED_FAILURE, {
        err: errText,
        error,
      }
    ));
    return null;
  }
};
